var _path, _rect, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyEInvoice = function SvgImgEmptyEInvoice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.765 13.2h-39.53a2.035 2.035 0 0 0-2.035 2.035v42.353a8.212 8.212 0 0 0 8.212 8.212h33.353a2.035 2.035 0 0 0 2.035-2.035v-48.53a2.035 2.035 0 0 0-2.035-2.035z",
    fill: "#fff",
    stroke: "#BDBDBD",
    strokeWidth: 1.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.541,
    y: 19.671,
    width: 15.623,
    height: 10.514,
    rx: 1.635,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#BDBDBD",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.706 23.714h12.353M23.941 45.572H35.06M43.706 29.786h12.353M23.941 51.643h14.824M23.941 57.714H40M48.647 57.714h7.412",
    stroke: "#BDBDBD",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.412 51.643c4.775 0 8.647-3.806 8.647-8.5 0-4.695-3.872-8.5-8.647-8.5-4.776 0-8.647 3.805-8.647 8.5 0 4.694 3.871 8.5 8.647 8.5zm2.053-6.306.001-.025c-.005-.893-.904-1.543-2.096-1.562-1.749-.029-3.195-.898-3.577-2.154-.407-1.332.648-2.72 2.404-3.158.389-.096.389-.096.389-.401 0-.039 0-.078-.002-.117a2.22 2.22 0 0 1 .004-.263c.032-.339.41-.596.85-.585.437.01.778.27.8.601l.001.041c.005.126.01.253-.004.377-.019.181.087.269.32.33 1.334.344 2.166 1.029 2.483 2.046.049.159.07.325.078.489.014.369-.33.654-.789.667-.479.013-.827-.252-.856-.637-.048-.646-.467-1.12-1.28-1.368-.792-.241-1.535-.132-2.17.29-.632.42-.828 1.07-.526 1.649.305.585 1.04.962 1.908.978 1.645.032 2.997.742 3.512 1.843.663 1.423-.35 2.963-2.288 3.47-.215.056-.312.081-.355.143-.034.05-.034.124-.034.258v.103c.002.086.002.172-.003.258-.021.342-.387.606-.824.604-.46-.002-.81-.267-.82-.624 0-.02-.002-.039-.003-.058-.004-.108-.01-.216.005-.322.027-.2-.092-.296-.343-.357-.902-.216-1.584-.64-2.058-1.244a2.127 2.127 0 0 1-.481-1.282c-.01-.368.33-.653.79-.666.477-.012.832.252.854.637.046.803.873 1.442 1.925 1.485 1.081.044 1.998-.509 2.17-1.312.01-.05.013-.102.015-.134z",
    fill: "#BDBDBD",
    fillOpacity: 0.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyEInvoice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img_empty_eInvoice.b09c67668c6bc29f83529694cbdeb840.svg";